import SectionHeading from "@/pages/home/components/SectionHeading";
import { accessSteps } from "@/mocks/siteData";

export default function AccessSteps() {
  return (
    <section id="access" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="Access Guide"
          title="首页访问流程：从确认地址到成功打开"
          desc="下面六个步骤是最常见的访问顺序。按顺序执行，可以在遇到问题时快速定位到底是哪一步出了状况。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {accessSteps.map((item) => (
            <article
              key={item.step}
              className="relative flex flex-col p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-heading font-black text-lg">
                  {item.step}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 leading-snug">
                  {item.title}
                </h3>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 flex-1">
                {item.desc}
              </p>
              <p className="mt-4 flex items-start gap-2 text-xs md:text-sm text-secondary-700 bg-secondary-50 rounded-lg px-3 py-2">
                <i className="ri-check-double-line mt-0.5" />
                {item.tip}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 p-5 rounded-xl border border-background-200 bg-background-100">
          <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 shrink-0">
            <i className="ri-arrow-down-double-line text-xl" />
          </span>
          <p className="text-sm md:text-base text-foreground-700">
            如果六步都顺利通过，说明你已成功进入首页；若卡在某一步，可直接跳到下方的
            <span className="text-foreground-950 font-medium">入门问题速查</span>，按症状查找对应处理方式。
          </p>
        </div>
      </div>
    </section>
  );
}